<!-- 解决方案列表 -->
<template>
    <div class="solution-list-container">
      <!-- 顶部搜索组件 -->
      <roof-search v-if="showNav" :middleContent="false" :rightContent="false" :showPlan="true" :planListMore="planListMore" :planList="planList" @handleSolution="handleSolution"></roof-search>
      <div class="solution-list footer" ref="activity_scroll" @scroll="activityScroll">
        <div class="list">
          <div class="item" v-for="(item,index) in solutionList" :key="index" @click="goIntro(item)">
            <div class="left-img">
              <!--            <van-image class="cover" src="http://cdn.juplus.cn/FnpC6aSNCabTnR4X-GlKgBVsEd_3"/>-->
              <img class="cover" :src="cdnUrl+item.cover_img_url" alt="">
            </div>
            <div class="right-content">
              <div class="title van-multi-ellipsis--l3">{{item.title}}</div>
              <div class="more">
                <button class="look-btn">查看内容</button>
              </div>
            </div>
          </div>
        </div>
        <div class="no-data" v-if="solutionList.length == 0">
          <img src="@/assets/img/no-data.png" alt="" class="no-data-img" width="100%">
          <p class="hint-text">暂无数据</p>
        </div>
      </div>
    </div>
</template>

<script>
import roofSearch from '@/components/roof-search'
import { wxShare } from '@/libs/wxjssdk'
import { getSolutionList } from '@/api/solution'
import { getAllCategory } from '@/api/product'
export default {
    data () {
        return {
            cdnUrl: this.$config.baseUrl.cdnUrl,
            showNav: true,
            id: '',
            title: '',
            solutionList: [],
            pageSize: 1,
            last_page: '',
            planListMore: [],
            planList: [],
            soluId: ''
        }
    },
    components: {
        roofSearch
    },
    computed: {
        whetherSignature () {
            return this.$store.state.user.whetherSignature
        }
    },
    watch: {
        whetherSignature (newVAl) {
            if (newVAl === true) {
                this.sharePage()
            }
        }
    },
    activated () {
        this.showNav = true
        this.sharePage()
        this.soluId = this.$route.query.id
        this.solutionList = []
        this.getSolutionListPort()
        
    },
    deactivated () {
        this.showNav = false
    },
    created () {
        const query = this.$route.query
        this.id = query.id || ''
        const solutionId = query.solution_id || ''
        this.title = query.title || '应用方案'
        this.soluId = this.$route.query.id
        this.$toast.loading({
            message: '加载中...',
            forbidClick: true,
            duration: 0
        })
        if (solutionId) {
            this.$router.push(
                {
                    name: 'solutionDetails',
                    query: {
                        id: solutionId,
                        isShowNav: true
                    }
                }
            )
        }
        
        this.getAllCategoryPort()
    },
    mounted () {
      
    },
    methods: {
      //
      handleSolution (data,type) {
        this.pageSize = 1
        data.id ? this.soluId = data.id : this.soluId = '' 
        // let isadd = this.planList.some(ele => data.id == ele.id)
        // if (type != '2' && !isadd) {
        //   this.planList.pop()
        //   this.planList.unshift(data)
        // }
        this.solutionList = []
        this.getSolutionListPort()
      },
      // 获取所有类别
      getAllCategoryPort () {
        getAllCategory({ type: 5 })
          .then(res => {
            // var categoryItems = res
            // categoryItems = this.formatData(categoryItems)
            // this.categoryItems = categoryItems
            let data = JSON.parse(JSON.stringify(res))
            this.planListMore = res
            this.planList = data.splice(0,2)
            // console.log('获取所有类', this.planList)
          })
          .catch(err => {
            this.$toast('获取类别接口失败')
            console.log('获取所有类别接口失败', err)
          })
        },
        sharePage () {
            const params = {
                title: this.title, // 分享标题
                desc: 'Eppendorf 应用解决方案', // 分享描述
                link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                imgUrl: window.location.origin + '/eppendorf_single/logo.png' // 分享图标
            }
            wxShare(params)
        },
        activityScroll () {
            var clientHeight = this.$refs.activity_scroll.clientHeight // 该容器的固定高度
            var scrollTop = this.$refs.activity_scroll.scrollTop // 滚动条距顶部的距离
            var scrollHeight = this.$refs.activity_scroll.scrollHeight // 内容的高度
            var inadvance = 150 // 距离底部距离
            if (scrollHeight - scrollTop - inadvance <= clientHeight) {
                if (this.pageSize < this.last_page) {
                    this.pageSize++
                    this.$toast.loading({
                        message: '加载中...',
                        forbidClick: true,
                        duration: 0
                    })
                    this.getSolutionListPort()
                }
            }
        },
        // 跳转方案简介
        goIntro (item) {
            this.$router.push({
                name: 'solutionDetails',
                query: {
                    id: item.id || ''
                }
            })
        },
        // 获取解决案例列表
        getSolutionListPort () {
          // console.log('接口提交的',+this.soluId);
          if (this.soluId) {
            this.soluId = this.soluId.toString().split()
          }
            var params = {
                page: this.pageSize,
                cid: this.soluId
                // solution_type_id: this.id
            }
            // if (this.soluId.length == 0) {
            //   delete params.cid
            // }
            getSolutionList(params).then(res => {
                this.$toast.clear()
                if (res.errCode === 0) {
                    var data = res.data
                    this.last_page = data.last_page
                    this.solutionList.push(...data.data)
                    document.title = this.title
                    this.sharePage()
                    // console.log(data)
                } else {
                    this.$toast(res.errMsg)
                }
            }).catch(err => {
                console.log('获取解决方案列表失败', err)
                this.$toast('获取解决方案接口出错，请稍后重试')
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.solution-list-container{
  padding-top: rem(46);
  background: #F5F3F9;
  height: 100vh;
  .solution-list{
    border-top: 1px solid #E2E2E2;
    width: 100%;
    height: 100%;
    overflow: auto;
    -webkit-overflow-scrolling: touch;
    .list{
      .item{
        height: rem(105);
        margin-top: rem(20);
        display: flex;
        padding: 0 rem(20);
        &:last-child{
          margin-bottom: rem(20);
        }
        .left-img{
          width: rem(160);
          height: 100%;
          border-radius: 4px;
          .cover{
            width: 100%;
            height: 100%;
            border-radius: 4px;
          }
        }
        .right-content{
          flex: 1;
          padding: 0 rem(12);
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          .title{
            color: #2C2C2C;
            font-size: rem(13);
            font-weight: bold;
          }
          .more{
            text-align: right;
            .look-btn{
              background: $base-color;
              border-radius:4px;
              color: #fff;
              outline: none;
              border: none;
              padding: rem(7) rem(9);
              font-size: 12px;
            }
          }
        }
      }
    }
    .no-data{
      width: 60%;
      display: block;
      margin: 0 auto;
      margin-top: rem(35);
      text-align: center;
      color: #b1acac;
      font-size: rem(13);
      padding-bottom: rem(10);
      .hint-text{
        margin: rem(10) 0;
      }
    }
  }
}
</style>
